<app-header [lightMode]="true" (openBooking)="openBookingModal()"></app-header>
<router-outlet></router-outlet>
<app-footer />

<!-- Global Booking Modal -->
@if (showBookingModal()) {
  <app-booking-modal (close)="closeBookingModal()"></app-booking-modal>
}
